var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.104492,
    y: 0.5,
    width: 35.9993,
    height: 35.9993,
    rx: 8,
    fill: "#2867B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6859 26.4997H10.3688V15.8175H13.6859V26.4997ZM12.0256 14.3604C10.9649 14.3604 10.1045 13.4818 10.1045 12.4211C10.1045 11.3601 10.9646 10.5 12.0256 10.5C13.0865 10.5 13.9466 11.3601 13.9466 12.4211C13.9466 13.4818 13.0859 14.3604 12.0256 14.3604ZM26.101 26.4997H22.7909V21.2997C22.7909 20.0604 22.7659 18.4711 21.0663 18.4711C19.3417 18.4711 19.0774 19.8175 19.0774 21.2104V26.4997H15.7638V15.8175H18.9452V17.2747H18.9917C19.4345 16.4354 20.5163 15.5497 22.1302 15.5497C25.4874 15.5497 26.1045 17.7604 26.1045 20.6318V26.4997H26.101Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1daf839a3265107ecc33b3987118d291.svg";
export { ForwardRef as ReactComponent };